var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 17V20C20.625 20.1989 20.546 20.3897 20.4053 20.5303C20.2647 20.671 20.0739 20.75 19.875 20.75H17.625C17.4261 20.75 17.2353 20.671 17.0947 20.5303C16.954 20.3897 16.875 20.1989 16.875 20V17",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 17V20C7.125 20.1989 7.04598 20.3897 6.90533 20.5303C6.76468 20.671 6.57391 20.75 6.375 20.75H4.125C3.92609 20.75 3.73532 20.671 3.59467 20.5303C3.45402 20.3897 3.375 20.1989 3.375 20V17",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5H22.5",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.5V17",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5V17",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 17H3.375V9.5L4.03125 4.89688C4.05609 4.71793 4.14469 4.55397 4.28075 4.43512C4.41682 4.31628 4.59122 4.25054 4.77188 4.25H19.2281C19.4088 4.25054 19.5832 4.31628 19.7192 4.43512C19.8553 4.55397 19.9439 4.71793 19.9688 4.89688L20.625 9.5V17Z",
    stroke: "#007DF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.625C7.16421 13.625 7.5 13.2892 7.5 12.875C7.5 12.4608 7.16421 12.125 6.75 12.125C6.33579 12.125 6 12.4608 6 12.875C6 13.2892 6.33579 13.625 6.75 13.625Z",
    fill: "#007DF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 13.625C17.6642 13.625 18 13.2892 18 12.875C18 12.4608 17.6642 12.125 17.25 12.125C16.8358 12.125 16.5 12.4608 16.5 12.875C16.5 13.2892 16.8358 13.625 17.25 13.625Z",
    fill: "#007DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.0493075ba9b583ae53b8471e23b94de5.svg";
export { ForwardRef as ReactComponent };